import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import { useDrag, useDrop } from 'react-dnd';
import classNames from 'classnames';
import Paper from '@material-ui/core/Paper';
import { Typography } from '@material-ui/core';
import ReorderIcon from '@material-ui/icons/Reorder';

const styles = {
  itemPaper: {
    padding: '15px',
    marginBottom: '10px',
    display: 'flex'
  },
  draggingOpaciy: {
    opacity: 0.2
  },
  nonDraggingOpacity: {
    opacity: 1
  },
  itemName: {
    margin: 'auto 15px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(setPropTypes(propTypes));

const Main = enhance(({ classes, index, id, name, itemType, moveItem }) => {
  const ref = useRef(null);
  const [{ isDragging }, drag] = useDrag({
    item: { type: itemType, id, index, name },
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  });

  const [, drop] = useDrop({
    accept: itemType,
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) {
        return;
      }
      const hoverBoundingRect = ref.current.getBoundingClientRect();
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      moveItem(dragIndex, hoverIndex);
      // 引数の値を変えようとしているため、ESLintに怒られるが
      // パフォーマンス向上（ドラッグ時のちらつき防止）のため、ここだけエラーを抑制して処理
      item.index = hoverIndex; // eslint-disable-line no-param-reassign
    }
  });
  drag(drop(ref));
  return (
    <Paper
      ref={ref}
      className={classNames(
        classes.itemPaper,
        isDragging ? classes.draggingOpaciy : classes.nonDraggingOpacity
      )}
    >
      <ReorderIcon color="action" />
      <Typography component="p" className={classes.itemName}>
        {name}
      </Typography>
    </Paper>
  );
});

export default withRouter(withStyles(styles)(Main));
